import * as $ from 'jquery';
import 'bootstrap';
import 'datepicker';
import 'selectize';
import * as moment from 'moment';
import { recaptchaObject } from "./recaptcha";
import { bookingFormCommon } from "./c005-bookingform-common";


export class groupBookingFormContent{
	private $groupError:Array<string> = [];
	private formEl:any = $('#group-booking--trip');

	$scope: any = $('#group-booking--form---container');
	$tripType: any = $('.trip-type--container');
	$groupDateSelReturn: any = $('.group-date--selector.group-return--trip');
	$groupDateSelOneway: any = $('.group-date--selector.group-oneway--trip');

	groupBookingNav(): any{
		let _self = this;

		_self.$scope.find('.groupReturnTrip').click(function(){
			_self.$tripType.find('li').removeClass('selected');
			$(this).addClass('selected');
			_self.$groupDateSelReturn.show();
			_self.$groupDateSelOneway.hide();
		});

		_self.$scope.find('.groupOneWayTrip').click(function(){
			_self.$tripType.find('li').removeClass('selected');
			$(this).addClass('selected');
			_self.$groupDateSelReturn.hide();
			_self.$groupDateSelOneway.show();
		});
	}

	groupBookingCalendar(): any{
		let _self = this;
		let nowDate:any      = new Date();
		let today:any        = new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);
		let maxLimitDate:any = new Date(nowDate.getFullYear()+1, nowDate.getMonth(), nowDate.getDate(), 0, 0, 0, 0);
		let bookingformcommon  = new bookingFormCommon();
		let $curDatepickerInst:any;
		let $curDatepickerTitle:string;


		function highlightDays(date: any) {
			var startDate = new Date($( "#groupReturnTripDepart" ).datepicker("getDate"));
			var endDate   = new Date($( "#groupReturnTripReturn" ).datepicker("getDate"));

			if ((startDate <= date) &&  (date <= endDate)) {
				return [true, 'highlight'];
			} else {
				return [true, ''];
			}
		}

		$(function() {
			let $dateFormat: any = 'd M yy',
			$departDate = _self.$scope.find('#groupReturnTripDepart')
			.datepicker({
				showButtonPanel: true,
				closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
				minDate: today,
				beforeShowDay: highlightDays,
				dateFormat: 'd M yy',
				maxDate: maxLimitDate,
				numberOfMonths: 2,
				beforeShow: function(ele:any, obj:any) {
					$curDatepickerInst = obj.dpDiv[0];
							$curDatepickerTitle = ele.dataset.datepickerTitle;
						},
						afterShow: function() {
							bookingformcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
						}
			})
			.on('change', function() {
				$returnDate.datepicker('option', 'minDate', getDate(this));
				window.setTimeout($.proxy(function() {
					$(this).next('#groupReturnTripReturn').focus();
				}, this), 100);
			}),
			$returnDate = _self.$scope.find('#groupReturnTripReturn')
			.datepicker({
				showButtonPanel: true,
				closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
				minDate: today,
				dateFormat: 'd M yy',
				maxDate: maxLimitDate,
				beforeShowDay: highlightDays,
				numberOfMonths: 2,
				beforeShow: function(ele:any, obj:any) {
					$curDatepickerInst = obj.dpDiv[0];
							$curDatepickerTitle = ele.dataset.datepickerTitle;
						},
						afterShow: function() {
							bookingformcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
						}
			})
			.on('change', function() {
				$departDate.datepicker('option', 'maxDate', getDate(this));
			});

			function getDate($element: any) {
				let $getDate: any;
				try {
					$getDate = $.datepicker.parseDate($dateFormat, $element.value);
				} catch(error) {
					$getDate = null;
				}
				return $getDate;
			}
		});

		$("#ui-datepicker-div").on('mouseover','td',function() {
			// custom formatting for group booking for datepicker
			if (_self.$scope.find('.trip-type--container .groupReturnTrip').hasClass('selected')) {
				if ($('#groupReturnTripDepart').val()){
					$(this).parent().addClass("finalRow");
					var parent4th = $(this).parents().eq(3); // tr

					//check if selecting on last cal
					if ($(parent4th).hasClass("ui-datepicker-group-last")) {
						$(".ui-datepicker-group-first td:not(.ui-datepicker-unselectable)").addClass("highlight");
					}
				}
			}
		});

		_self.$scope.find('#groupOneWayTripDepart').datepicker({
			showButtonPanel: true,
			closeText: '<i class="fa fa-times" aria-hidden="true"></i>',
			minDate: today,
			dateFormat: 'd M yy',
			maxDate: maxLimitDate,
			numberOfMonths: 2,
			beforeShow: function(ele:any, obj:any) {
				$curDatepickerInst = obj.dpDiv[0];
				$curDatepickerTitle = ele.dataset.datepickerTitle;
			},
			afterShow: function() {
				bookingformcommon.appendDatepickerTitle($curDatepickerTitle, $curDatepickerInst);
			}
		});
	}

	groupContactlist(): any {
		// every static rendering will use promise. no need to worry about async issue
		let _self = this;
		let defer = $.Deferred();
		let dataUrl = _self.$scope.find('.group-booking--tripcontainer').attr('data-get-url');

		$.get(dataUrl)
		.done((data: any) => {
			let contactItems = "<option value=''> </option>";
			for (let i = 0; i < data.Phonecodes.length; i++) {
				contactItems +=  "<option value='" + data.Phonecodes[i].Code+ "'>" + data.Phonecodes[i].Name+ " (" + data.Phonecodes[i].Code+ ")" + "</option>";
				}
			defer.resolve(contactItems);
		})
		.fail((error:any) => {
			defer.reject(error);
		});

		return defer.promise();
	}

	initGroupBookingValidation(): any {
		let _self: any = this;
		let $groupTCCheck: any = _self.$scope.find('#groupTnC');
		let $groupTC: any = false;
		$groupTCCheck.click(function(){
			$groupTC = $groupTCCheck.is(':checked');
			if ($groupTC) {
				$groupTCCheck.parent().removeClass('has-error');
			} else {
				$groupTCCheck.parent().addClass('has-error');
			}
		});		
	}

	/**
	 * regex formula for email string
	 * @param {string} $campaignEmail [test string]
	 */
	validateEmail($campaignEmail:string){
		let emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
		return emailReg.test($campaignEmail);
	}

	initSelectize(destItems: any, contactItems:any): void {
		let _self = this;
	
		// from & to dropdowns
		_self.$scope.find('#fromLocationGroup').html(destItems);
		_self.$scope.find('#fromLocationGroup').selectize({
			onFocus: function() {
				$('.fromLocation .booking-form--title').addClass('input-filled');
				$('.fromLocation .selectize-control.single .selectize-input').addClass('select-filled');
				$('select#fromLocationGroup').parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$('select#fromLocationGroup').parent().find('.booking-form--title').removeClass('has-error');
				$('select#fromLocationGroup').parent().removeClass('has-error');
			},
			onChange: function(val:any) {
				$('.fromLocation .booking-form--title').addClass('input-filled');
				$('.fromLocation .selectize-control.single .selectize-input').addClass('select-filled');
			},
			onBlur: function(){
				let $fromLocationChange = $("#fromLocationGroup option:selected").text();
				if ($fromLocationChange == ''){
					$('.fromLocation .booking-form--title').removeClass('input-filled');
					$('.fromLocation .selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$('.fromLocation .booking-form--title').addClass('input-filled');
					$('.fromLocation .selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			selectOnTab: true
		});

		_self.$scope.find('#toLocationGroup').html(destItems);
		_self.$scope.find('#toLocationGroup').selectize({
			onFocus: function() {
				$('.toLocation .booking-form--title').addClass('input-filled');
				$('.toLocation .selectize-control.single .selectize-input').addClass('select-filled');
				$('select#toLocationGroup').parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$('select#toLocationGroup').parent().find('.booking-form--title').removeClass('has-error');
				$('select#toLocationGroup').parent().removeClass('has-error');
			},
			onChange: function(value: any){
				$('.toLocation .booking-form--title').addClass('input-filled');
				$('.toLocation .selectize-control.single .selectize-input').addClass('select-filled');
				if ($('#fromLocationGroup').val() === $('#toLocationGroup').val()){
					$('select#toLocationGroup').parent().find('.selectize-control .selectize-input').addClass('has-error');
					$('select#toLocationGroup').parent().find('.booking-form--title').addClass('has-error');
				}
				else{
					$('select#toLocationGroup').parent().find('.selectize-control .selectize-input').removeClass('has-error');
					$('select#toLocationGroup').parent().find('.booking-form--title').removeClass('has-error');
				}
			},
			onBlur: function(){
				let $toLocationChange = $("#toLocationGroup option:selected").text();
				if ($toLocationChange == ''){
					$('.toLocation .booking-form--title').removeClass('input-filled');
					$('.toLocation .selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$('.toLocation .booking-form--title').addClass('input-filled');
					$('.toLocation .selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			selectOnTab: true
		});

		// country code dropdowns
		_self.$scope.find('#groupCountryCode').html(contactItems);
		_self.$scope.find('#groupCountryCode').selectize({
			onFocus: function() {
				$('.groupCountryCode .booking-form--title').addClass('input-filled');
				$('.groupCountryCode .selectize-control.single .selectize-input').addClass('select-filled');
				$('select#groupCountryCode').parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$('select#groupCountryCode').parent().find('.booking-form--title').removeClass('has-error');
				$('select#groupCountryCode').parent().removeClass('has-error');
			},
			onChange: function(value: any){
				$('.groupCountryCode .booking-form--title').addClass('input-filled');
				$('.groupCountryCode .selectize-control.single .selectize-input').addClass('select-filled');
			},
			onBlur: function(){
				let $groupCountryCodeChange = $("#groupCountryCode option:selected").text();
				if ($groupCountryCodeChange == ''){
					$('.groupCountryCode .booking-form--title').removeClass('input-filled');
					$('.groupCountryCode .selectize-control.single .selectize-input').removeClass('select-filled');
				} else {
					$('.groupCountryCode .booking-form--title').addClass('input-filled');
					$('.groupCountryCode .selectize-control.single .selectize-input').addClass('select-filled');
				}
			},
			selectOnTab: true
		});
	}

	initRecaptcha():any {
		let _self = this;
		let _body = $('body');
		let recaptchaobj = new recaptchaObject();

		let recaptchaInfo:recaptchaInfo = {
			id: 'groupTC-recaptcha',
			cb: 'recaptchaGroupBookingSuccess',
			cbObj:	function (response:any) {
								(document.getElementById('groupTC-recaptcha') as HTMLInputElement).value = 'true';
							},
			displayId: 'group-booking--grecaptcha',
			formEl: _self.formEl
		};

		recaptchaobj.createRecaptchaField(recaptchaInfo);
	}

	groupFormSubmit(): any{
		let _self = this;
		let $adultPassengerGen: any = $('#adultPassenger');
		let $childrenPassengerGen: any = $('#childrenPassenger');
		let $infantPassengerGen: any = $('#infantPassenger');
		$adultPassengerGen.addClass('input-focused');
		$adultPassengerGen.parent().find('label').addClass('input-filled');
		$childrenPassengerGen.addClass('input-focused');
		$childrenPassengerGen.parent().find('label').addClass('input-filled');
		$infantPassengerGen.addClass('input-focused');
		$infantPassengerGen.parent().find('label').addClass('input-filled');

		_self.$scope.find('#groupSubmitBtn').click((evt:any) => {
			evt.preventDefault();
			let _self: any = this;
			let $groupErrorDiv: any = _self.$scope.find('.group-error--validation');
			let $fromLocationGroup: any = _self.$scope.find('#fromLocationGroup');
			let $toLocationGroup: any = _self.$scope.find('#toLocationGroup');
			let $groupReturnTripDepart: any = _self.$scope.find('#groupReturnTripDepart');
			let $groupReturnTripReturn: any = _self.$scope.find('#groupReturnTripReturn');
			let $groupOneWayTripDepart: any = _self.$scope.find('#groupOneWayTripDepart');
			let $adultPassenger: any = _self.$scope.find('#adultPassenger');
			let $childrenPassenger: any = _self.$scope.find('#childrenPassenger');
			let $infantPassenger: any = _self.$scope.find('#infantPassenger');
			let $groupFirstName: any = _self.$scope.find('#groupFirstName');
			let $groupFamilyName: any = _self.$scope.find('#groupFamilyName');
			let $groupCountryCode: any = _self.$scope.find('#groupCountryCode');
			let $groupPhoneNumber: any = _self.$scope.find('#groupPhoneNumber');
			let $groupEmailInput: any = _self.$scope.find('#groupEmail');
			let $groupEmail: any = $groupEmailInput.val();
			let $groupTandCheck: any = _self.$scope.find('#groupTC');
			let $groupTandC: any = $groupTandCheck.is(':checked');
			let $groupTCCheck: any = _self.$scope.find('#groupTnC');
			let $groupTC: any = $groupTCCheck.is(':checked');
			let $groupOneWay: any = _self.$scope.find('.groupOneWayTrip #groupOneWayTripDepart');
			let $groupValidationContent: any = _self.$scope.find('#group-validation--content');
			let $groupBookingTrip: any = $('#group-booking--trip');
			let $groupBookingID: any = _self.$scope.find('.group-booking--tripcontainer');
			let $groupBookingClass: any = _self.$scope;
			let $groupBookingSuccess: any = $('.group-booking--success');
			let $groupBookingUnSuccess: any =$('.group-booking--unsuccess');
			let $groupRecaptchaDiv: any = _self.$scope.find('#groupTC-recaptcha');
			let $groupBookingHeader: any = _self.$scope.find('.group-booking--header');
			let $validationSuccess: any = true;
		
			_self.$groupError = [];
			$groupErrorDiv.show();

			if ($fromLocationGroup.val() == '' || !$fromLocationGroup.val()) {
				$fromLocationGroup.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$fromLocationGroup.parent().find('.booking-form--title').addClass('has-error');
				$fromLocationGroup.parent().addClass('has-error');
				let $fromLocValidate:any = $fromLocationGroup.attr('data-departloc');
				this.$groupError.push('<strong>'+$fromLocationGroup.parent().find('label').text()+':</strong> '+$fromLocValidate);
				$validationSuccess = false;
			} else {
				$validationSuccess = $validationSuccess ? true : false;
				$fromLocationGroup.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$fromLocationGroup.parent().find('.booking-form--title').removeClass('has-error');
			}

			if ($toLocationGroup.val() == '' || !$toLocationGroup.val()) {
				$toLocationGroup.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$toLocationGroup.parent().find('.booking-form--title').addClass('has-error');
				$toLocationGroup.parent().addClass('has-error');
				let $toLocValidate:any = $toLocationGroup.attr('data-destloc');
				this.$groupError.push('<strong>'+$toLocationGroup.parent().find('label').text()+':</strong> '+$toLocValidate);
				$validationSuccess = false;
			} else {
				$validationSuccess = $validationSuccess ? true : false;
				$toLocationGroup.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$toLocationGroup.parent().find('.booking-form--title').removeClass('has-error');
			}

			/** IBE From/To Location identical value validation */
			if ($fromLocationGroup.val() === $toLocationGroup.val()) {
				$toLocationGroup.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$toLocationGroup.parent().find('.booking-form--title').addClass('has-error');
				$validationSuccess = false;

				if (!($fromLocationGroup.val() == '' || $toLocationGroup.val() == '')){
					let $fromLoLocValidate:any = $fromLocationGroup.attr('data-deptDestLoc');
					this.$groupError.push('<strong>'+$fromLocationGroup.parent().find('label').text() +', '+ $toLocationGroup.parent().find('label').text()+':</strong> '+$fromLoLocValidate);
				}
			}

			if (_self.$scope.find('.groupOneWayTrip').hasClass('selected')){
				if ($groupOneWayTripDepart.val() == '') {
					$groupOneWayTripDepart.parent().addClass('has-error');
					let $travelDateOne:any = $groupOneWayTripDepart.attr('data-traveldateOne');
					this.$groupError.push('<strong>'+$groupOneWayTripDepart.parent().find('label').text()+':</strong> '+$travelDateOne);
					$validationSuccess = false;
				} else {
					$groupOneWayTripDepart.parent().parent().removeClass('has-error');
				}
			} else {
				/** IBE Return Trip Departure Date empty field validation */
				if ($groupReturnTripDepart.val() == '') {
					$groupReturnTripDepart.parent().addClass('has-error');
					let $travelDepDate:any = $groupReturnTripDepart.attr('data-travelDepdate');
					this.$groupError.push('<strong>'+$groupReturnTripDepart.parent().find('label.dep-title').text()+':</strong> '+$travelDepDate);
					$validationSuccess = false;
				} else {
					$groupReturnTripDepart.parent().parent().parent().removeClass('has-error');
				}
				/** IBE Return Trip Return Date empty field validation */
				if ($groupReturnTripReturn.val() == '') {
					$groupReturnTripReturn.parent().parent().parent().addClass('has-error');
					let $travelEndDate:any = $groupReturnTripReturn.attr('data-travelRetdate');
					this.$groupError.push('<strong>'+$groupReturnTripReturn.parent().find('label.ret-title').text()+':</strong> '+$travelEndDate);
					$validationSuccess = false;
				} else {
					$groupReturnTripReturn.parent().parent().parent().removeClass('has-error');
				}
			}
			
			if ($adultPassenger.val() == ''|| $adultPassenger.val() == 0 ){
				let $adultPassengerValidate:any = $adultPassenger.attr('data-adult');
				this.$groupError.push('<strong>'+$adultPassenger.parent().find('label').text()+':</strong> '+$adultPassengerValidate);
				$adultPassenger.parent().addClass('has-error');
				$adultPassenger.parent().find('.form-title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$validationSuccess = $validationSuccess ? true : false;
				$adultPassenger.parent().removeClass('has-error');
				$adultPassenger.parent().find('.form-title').removeClass('has-error');
			}

			if ($childrenPassenger.val() == '') {
				var $childrenPassengerValidate = $childrenPassenger.attr('data-children');
				this.$groupError.push('<strong>' + $childrenPassenger.parent().find('label').text() + ':</strong> ' + $childrenPassengerValidate);
				$childrenPassenger.parent().addClass('has-error');
				$childrenPassenger.parent().find('.form-title').addClass('has-error');
				$validationSuccess = false;
			}
			else {
				$validationSuccess = $validationSuccess ? true : false;
				$childrenPassenger.parent().removeClass('has-error');
				$childrenPassenger.parent().find('.form-title').removeClass('has-error');
			}
			if ($infantPassenger.val() == '') {
				var $infantPassengerValidate = $infantPassenger.attr('data-infant');
				this.$groupError.push('<strong>' + $infantPassenger.parent().find('label').text() + ':</strong> ' + $infantPassengerValidate);
				$infantPassenger.parent().addClass('has-error');
				$infantPassenger.parent().find('.form-title').addClass('has-error');
				$validationSuccess = false;
			}
			else {
				$validationSuccess = $validationSuccess ? true : false;
				$infantPassenger.parent().removeClass('has-error');
				$infantPassenger.parent().find('.form-title').removeClass('has-error');
			}

			if ($groupTC) {
				$groupTCCheck.parent().removeClass('has-error');
			} else {
				$groupTCCheck.parent().addClass('has-error');
			}

			if ($groupFirstName.val() == ''){
				let $groupFirstNameValidate:any = $groupFirstName.attr('data-firstname');
				this.$groupError.push('<strong>'+$groupFirstName.parent().find('label').text()+':</strong> '+$groupFirstNameValidate);
				$groupFirstName.parent().addClass('has-error');
				$groupFirstName.parent().find('.form-title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$validationSuccess = $validationSuccess ? true : false;
				$groupFirstName.parent().removeClass('has-error');
				$groupFirstName.parent().find('.form-title').removeClass('has-error');
			}

			if ($groupFamilyName.val() == ''){
				let $groupFamilyNameValidate:any = $groupFamilyName.attr('data-lastname');
				this.$groupError.push('<strong>'+$groupFamilyName.parent().find('label').text()+':</strong> '+$groupFamilyNameValidate);
				$groupFamilyName.parent().addClass('has-error');
				$groupFamilyName.parent().find('.form-title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$validationSuccess = $validationSuccess ? true : false;
				$groupFamilyName.parent().removeClass('has-error');
				$groupFamilyName.parent().find('.form-title').removeClass('has-error');
			}

			if ($groupCountryCode.val() == '' || !$groupCountryCode.val()) {
				$groupCountryCode.parent().find('.selectize-control .selectize-input').addClass('has-error');
				$groupCountryCode.parent().find('.booking-form--title').addClass('has-error');
				$groupCountryCode.parent().addClass('has-error');
				let $groupCountryCodeValidate:any = $groupCountryCode.attr('data-countrycode');
				this.$groupError.push('<strong>'+$groupCountryCode.parent().find('label').text()+':</strong> '+$groupCountryCodeValidate);
				$validationSuccess = false;
			} else {
				$validationSuccess = $validationSuccess ? true : false;
				$groupCountryCode.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$groupCountryCode.parent().find('.booking-form--title').removeClass('has-error');
			}

			if ($groupPhoneNumber.val() == ''){
				let $groupPhoneNumberValidate:any = $groupPhoneNumber.attr('data-phoneno');
				this.$groupError.push('<strong>'+$groupPhoneNumber.parent().find('label').text()+':</strong> '+$groupPhoneNumberValidate);
				$groupPhoneNumber.parent().addClass('has-error');
				$groupPhoneNumber.parent().find('.form-title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$validationSuccess = $validationSuccess ? true : false;
				$groupPhoneNumber.parent().removeClass('has-error');
				$groupPhoneNumber.parent().find('.form-title').removeClass('has-error');
			}

			/** validate email address */
			if ((!(this.validateEmail($groupEmail))) || $groupEmail == ''){
				let $groupEmailValidate:any = $groupEmailInput.attr('data-email');
				this.$groupError.push('<strong>'+$groupEmailInput.parent().find('label').text()+':</strong> '+$groupEmailValidate);
				$groupEmailInput.parent().addClass('has-error');
				$groupEmailInput.parent().find('.form-title').addClass('has-error');
				$validationSuccess = false;
			} else{
				$validationSuccess = $validationSuccess ? true : false;
				$groupEmailInput.parent().removeClass('has-error');
				$groupEmailInput.parent().find('.form-title').removeClass('has-error');
			}
			if($('input[name="groupTC"]:checked').length<1)
			{
				
				let $groupTCCheckValidate:any = $groupTCCheck.attr('data-tandc');
				this.$groupError.push('<strong>'+"Terms and conditions"+':</strong> '+"This value is required");
				$validationSuccess = false;
			}
			else {
				$validationSuccess = $validationSuccess ? true : false;
				$fromLocationGroup.parent().find('.selectize-control .selectize-input').removeClass('has-error');
				$fromLocationGroup.parent().find('.booking-form--title').removeClass('has-error');
			}
			if ($groupRecaptchaDiv.val() == ''){
				let $groupRecaptchaDivValidate:any = $groupRecaptchaDiv.attr('data-recaptcha');
				this.$groupError.push('<strong>'+$groupRecaptchaDiv.parent().find('label').text()+':</strong> '+$groupRecaptchaDivValidate);
				$groupRecaptchaDiv.parent().find('#group-booking--grecaptcha').children(':first-child').addClass('has-error');
				$groupRecaptchaDiv.parent().find('.form-title').addClass('has-error');
				$validationSuccess = false;
			} else {
				$validationSuccess = $validationSuccess ? true : false;
				$groupRecaptchaDiv.parent().find('#group-booking--grecaptcha').children(':first-child').removeClass('has-error');
				$groupRecaptchaDiv.parent().find('.form-title').removeClass('has-error');
			}

			let $validationContainer:any = $("#group-validation--content").html('<ul class="validation--error-list"></ul>').find('.validation--error-list');
			let $validationMessagelist:any = $validationContainer;

			for (var i=0, len=this.$groupError.length; i<len; i++) {
				$validationMessagelist.append('<li data-id="'+i+'">' + this.$groupError[i] + '</li>');
			}
			//$groupValidationContent.text(this.$groupError.join(', '));

			/** show success message if validations passed */
			if ($validationSuccess) {
				let bcommon: any = new bookingFormCommon();

				let validation:any = _self.formEl.parsley({
					errorClass: 'has-error',
					classHandler: function (el:any) {
						return el.$element.closest('.form-item');
					},
				});
				
				let htmlFormData:any = new FormData(validation.$element[0]);
					bcommon.preloader();
					$.ajax({
						type: 'POST',
						url:'/bin/services/new/GroupTravelFormServlet',
						data: htmlFormData,
						success: function(msg:any) {
							bcommon.preloaderClose();
							$groupErrorDiv.hide();
							$groupBookingTrip.hide();
						//	$groupBookingID.hide();
							// $groupBookingClass.hide();
							// $groupBookingHeader.hide();
							 $groupBookingSuccess.show();
							 document.querySelector('.group-booking--success').scrollIntoView(true);
							 setTimeout(() => {
								window.scrollBy(0,-40);
							 }, 800);
							 $groupBookingUnSuccess.hide();
						},
						error: function(error:any) {
							bcommon.preloaderClose();
							$groupErrorDiv.hide();
							$groupBookingTrip.hide();
							//$groupBookingID.hide();
							// $groupBookingClass.hide();
							 //$groupBookingHeader.hide();
							 $groupBookingSuccess.hide();
							 document.querySelector('.group-booking--unsuccess').scrollIntoView(true);
							 setTimeout(() => {
								window.scrollBy(0,-40);
							 }, 800);
							 $groupBookingUnSuccess.show();
					},
						cache: false,
						contentType: false,
						processData: false,
					});
			} else {
					//$groupBookingUnSuccess.show();
					$groupBookingSuccess.hide();
			}
		});
	}

	groupSwapFromToLocation(): any{
		let _self = this;

		_self.$scope.find('.flight-trip--icon').click(function(){
			$(this).toggleClass("rotate-180");
			let $fromLocationGetVal: any = $('#fromLocationGroup')[0].selectize.getValue();
			let $toLocationGetVal: any = $('#toLocationGroup')[0].selectize.getValue();
			$('#fromLocationGroup')[0].selectize.setValue($toLocationGetVal);
			$('#toLocationGroup')[0].selectize.setValue($fromLocationGetVal);
		});
	}
}


let scope:Element = document.querySelector('.group-booking--tripcontainer');
if (scope){
	try {
	let bookingformcommon = new bookingFormCommon();
	let grpbookform = new groupBookingFormContent();
			grpbookform.groupBookingNav();
			grpbookform.groupBookingCalendar();
			$(document).ready(function(){
				grpbookform.initGroupBookingValidation();
				$.when(window['ibeOnDList'], grpbookform.groupContactlist()).done((listData: any, contactItems: any) => {
					console.log('%cc048groupbooking%c ond done', 'background-color: yellow', 'background-color: initial');
					// onload use revenue OnD
					let listItems:string = bookingformcommon.parseOnDListItems(listData, 'revenue');

					grpbookform.initSelectize(listItems, contactItems);
				});
			});

	grpbookform.initRecaptcha();
	grpbookform.groupFormSubmit();
	grpbookform.groupSwapFromToLocation();
	} catch(e) {console.error(e);}
}
